var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { staticClass: "c-card", attrs: { href: _vm.item.url } }, [
    _vm.item.image && _vm.item.image.url
      ? _c("div", { staticClass: "c-card__image-frame" }, [
          _c("img", {
            staticClass: "c-card__image",
            attrs: {
              src: _vm.item.image.url,
              alt: _vm.item.image.alt,
              width: _vm.item.image.width,
              height: _vm.item.image.height
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "c-card__details" }, [
      _c("div", { staticClass: "c-card__title" }, [
        _c("h3", { staticClass: "c-card__heading u-text-color-brand-two" }, [
          _vm._v(_vm._s(_vm.item.heading))
        ]),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "c-card__button-icon",
            attrs: { "aria-hidden": "true", focusable: "false" }
          },
          [
            _c("use", {
              attrs: {
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xlink:href": "#arrow-right--round"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "c-card__description" }, [
        _vm._v(_vm._s(_vm.item.description))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ab05c90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab05c90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/card-list/Card.vue
// module id = 624
// module chunks = 0